import { render } from "./uiButton.vue?vue&type=template&id=0a080d9a&scoped=true"
import script from "./uiButton.vue?vue&type=script&lang=js"
export * from "./uiButton.vue?vue&type=script&lang=js"

import "./uiButton.vue?vue&type=style&index=0&id=0a080d9a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a080d9a"

export default script